export default function getSiteName({ title, subTitle }) {
  return subTitle ? `${title} ${subTitle}` : title;
}
